<template>
    <c-modal
        v-model="model"
        centered size="md"
        title="Attention"
        :tag="false"
    >
        <template>
            <div class="text-center">
                Please ask this user to check his/her Email inbox or cell phone texts for a temporary login password we just sent.
            </div>
        </template>
        <template #actions>
            <b-row class="flex-grow-1 justify-content-center">
                <b-col cols="6">
                    <b-btn variant="danger" block class="text-nowrap" @click="model = false">Close</b-btn>
                </b-col>
            </b-row>
        </template>
    </c-modal>
</template>

<script>
    import CModal from "@/components/shared/Cmodal";
    export default {
        name: "attentionRemoveItems",
        components: {CModal},
        props: {
            tag: {type: [String, null]},
            value: {type: Boolean, default: false}
        },
        computed: {
          model: {
              get () {
                  return this.value
              },
              set(val) {
                  this.$emit('input', val)
              }
          }
        },
        data () {
            return {
            }
        },
        methods: {
        }
    }
</script>

<style scoped>

</style>
